import { updateConfigurables } from 'actions/ticketAction'

export const handlers = ({ local }) => ({
  handleLoad: async () => {
    await updateConfigurables(local)
  },
})
